import _DialogActions from "@mui/material/DialogActions";
import _DialogTitle from "@mui/material/DialogTitle";
import _Dialog from "@mui/material/Dialog";
import _Button from "@mui/material/Button";
import _Public from "@mui/icons-material/Public";
import _DialogContent from "@mui/material/DialogContent";
import _Typography from "@mui/material/Typography";
import _Tooltip from "@mui/material/Tooltip";
import _IconButton from "@mui/material/IconButton";
import _Close from "@mui/icons-material/Close";
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { Trans } from 'react-i18next';
import { styled } from 'styled-components';
import { parkingNetworks } from '../models';
export function ParkingDialog({
  parking,
  ...props
}) {
  const network = parking?.network && parkingNetworks[parking.network] || null;
  return /*#__PURE__*/React.createElement(_Dialog, _extends({
    fullWidth: true,
    maxWidth: "md"
  }, props), /*#__PURE__*/React.createElement(StyledDialogTitle, null, network && /*#__PURE__*/React.createElement(StyledHeaderLogo, {
    title: network.title,
    url: network.icon
  }), /*#__PURE__*/React.createElement(Trans, {
    i18nKey: "commons.poi.categories.parking_one"
  })), /*#__PURE__*/React.createElement(CloseButtonWrapper, null, /*#__PURE__*/React.createElement(_Tooltip, {
    placement: "left",
    title: /*#__PURE__*/React.createElement(Trans, {
      i18nKey: "commons.actions.close"
    })
  }, /*#__PURE__*/React.createElement(_IconButton, {
    onClick: () => props.onClose(),
    size: "small"
  }, /*#__PURE__*/React.createElement(_Close, null)))), /*#__PURE__*/React.createElement(_DialogContent, null, /*#__PURE__*/React.createElement(_Typography, {
    color: "textSecondary",
    component: "p",
    variant: "caption"
  }, parking?.capacity && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Trans, {
    count: parking.capacity,
    i18nKey: "commons.parking.racks",
    values: {
      count: parking.capacity,
      capacity: parking.capacity
    }
  }), "\xA0\u2022\xA0"), parking?.locked && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Trans, {
    i18nKey: "commons.parking.locked"
  }), "\xA0\u2022\xA0"), parking?.sheltered && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Trans, {
    i18nKey: "commons.parking.sheltered"
  }), "\xA0\u2022\xA0"), parking?.supervised && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Trans, {
    i18nKey: "commons.parking.supervised"
  }), "\xA0\u2022\xA0"), /*#__PURE__*/React.createElement(Trans, {
    i18nKey: parking?.free ? 'commons.parking.free' : 'commons.parking.toll'
  }))), parking?.website && /*#__PURE__*/React.createElement(StyledDialogActions, null, /*#__PURE__*/React.createElement(_Button, {
    color: "primary",
    component: "a",
    href: parking.website,
    rel: "noreferrer",
    size: "small",
    target: "_blank"
  }, /*#__PURE__*/React.createElement(_Public, null), /*#__PURE__*/React.createElement(Trans, {
    i18nKey: "commons.website"
  }))));
}
const StyledDialogTitle = styled(_DialogTitle)`
  && {
    padding-right: 46px;

    h2 {
      align-items: center;
      display: flex;
    }
  }
`;
const StyledHeaderLogo = styled.div`
  align-self: center;
  background-image: ${({
  url
}) => `url(${url})`};
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  height: 48px;
  margin-right: 8px;
  width: 48px;
`;
const CloseButtonWrapper = styled.div`
  position: absolute;
  right: 8px;
  top: 8px;

  button {
    background-color: rgba(255, 255, 255, 0.8);
  }
`;
const StyledDialogActions = styled(_DialogActions)`
  svg {
    margin-right: 4px;
  }
`;